import { useCallback } from "react";
import { useLocation, useSearchParams } from "react-router-dom";

export type SearchParamChanges = Record<string, string | number | null | undefined>;

/** Merges changes into the URL query (null/""/undefined removes a key), keeping history and navigation state. */
export const useSearchParamUpdater = () => {
  const [, setSearchParams] = useSearchParams();
  const { state } = useLocation();
  return useCallback(
    (changes: SearchParamChanges) => {
      // The router's `prev` lags behind a navigation that hasn't re-rendered yet; the address bar doesn't.
      const next = new URLSearchParams(globalThis.location.search);
      for (const [key, value] of Object.entries(changes)) {
        if (value === null || value === undefined || value === "") next.delete(key);
        else next.set(key, String(value));
      }
      setSearchParams(next, { replace: true, state });
    },
    [setSearchParams, state]
  );
};
